/**
 * This app's public (unauthenticated) route paths, used by the shell in
 * `app.ts` to pick the chrome-less layout for the auth screens.
 *
 * Route paths are application data (Wave 3 seam): the library ships the auth
 * screens, but which URLs they mount on — and therefore which URLs skip the
 * signed-in shell — is decided here, next to `app.routes.ts`, which defines
 * the same paths. Keep the two files in sync; a route added there that must
 * render outside the shell belongs here too.
 */
export const PUBLIC_ROUTE_PATHS = [
  '/login',
  '/authenticate',
  '/forgot-password',
  '/reset-password',
  '/set-password',
] as const;
